module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter2"
    }
  }), _vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Water occupies over 70 percent of the planet Earth, providing a multitude of sailing venues, from high-latitude exploration to sultry equatorial islands and all of the seas, bays, and lakes in between. To some offshore sailors these waterways provide “highways” to travel from place to place; to racing sailors they are a unique playing field that is ever changing with the weather; to cruising sailors they provide a peaceful setting to while away time—and for all, being at sea is a welcome break from life ashore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Working in the sailing industry around the world has provided me with a lifetime of opportunities to make friends who share a common bond of spending time on the water. Often we return to the same places—a favorite regatta in Newport or Sardinia, a familiar anchorage in Maine or New Zealand—while other times an invitation to try something new takes us farther afield—to Turkey, Antarctica, or the fjords of Alaska.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('em', [_vm._v("Fifty Places to Sail Before You Die,")]), _vm._v(" Chris Santella has interviewed professional sailors, writers, boatbuilders, former Olympians, sailing instructors, yachting photographers, and others to find out their favorite places, and has endeavored to bring these places to life. Some of these you may know, but the description of others is likely to spur you on to pack your duffle and head out to explore some intriguing destinations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In ports and harbors around the world there are always people to be found doing just what we all like to do: mess around in boats in a special place. I hope this title helps lead you to new ports and new friends.")]), _vm._v(" "), _c('p', {
    staticClass: "rightm"
  }, [_c('strong', [_vm._v("— "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SUSAN MAFFEI PLOWDEN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171fb00a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter2.vue
// module id = 78
// module chunks = 0